const enUS = {
    "component":{
        "ZmDialog":{
            "内容有修改,是否确认关闭？":"The content has been modified, are you sure to close it?",
            "确定":"OK",
            "提示":"Hint",
            "取消":"Cancel"
        },
        "ZmTable":{
            "序号":"No.",
            "复制当前行":"Copy the current line",
            "复制选择行":"Copy selection line",
            "复制所有行":"Copy all rows",
            "请选择数据列或未获取到数据":"Please select a data column or no data is obtained",
            "以下单号在查询结果中不存在：":'The following tracking numbers do not exist in the query results: ',
            "共":"altogether",
            "笔":"笔",
            "以下单号存在重复：":"The following tracking numbers are duplicated:",
            "复制区域内容":"Copy area content",
            "内容已复制到粘贴板":"The content has been copied to the pasteboard",
            "复制失败！":"Copy failed!",
        },
        "ZmTableConfig":{
            "表格配置":"Form configuration",
            "可选格式":"Optional format",
            "保存":"Save",
            "另存为":"Save as",
            "删除":"Delete",
            "序号":"No.",
            "字段名称":"Field Name",
            "输入关键字搜索":"Enter keywords to search",
            "是否显示":"Whether to show",
            "排序":"Sort",
            "重排":"Rearrange",
            "列宽":"Column width",
            "顺序重置":"Order reset",
            "注意：关于列宽调整，需在主页面上设置好，再做保存":"Note: Regarding column width adjustment, you need to set it on the main page before saving",
            "保存并加载":"Save and load",
            "取消":"Cancel",
            "请选择数据":"Please select data",
            "已经是列表中第一条数据！":"Already the first data in the list!",
            "请选择列":"请选择列",
            "已经是列表中最后一条数据！":"Already the last data in the list!",
            "请输入模版名称":"Please enter the template name",
            "提示":"Tip",
            "确定":"Determine",
            "表格配置另存为成功":'The table configuration was saved as successfully',
            "表格配置另存为失败":"Failed to save table configuration as",
            "取消另存为":"Cancellation",
            "必须设置显示列":"Must set display column",
            "请设置配置信息":"Please set configuration information",
            "请选择表格配置":"Please select form configuration",
            "是否删除此格式":"Whether to delete this format",
            "格式删除成功":'Format deleted successfully ',
            "格式删除失败":'Format deletion failed ',
            "请选择格式":"Please select the format!",
            "表格配置信息保存成功":"The table configuration information was saved successfully",
            "表格配置信息保存失败":"Failed to save table configuration information",
        },
        "ZmImpBtn":{
            "可用格式":"Available formats",
            "字段编码":"Field encoding",
            "序号":"No.",
            "请输入格式名称":"Please enter the format name",
            "列号":"Column Number|Title",
            "必填":"Required",
            "另存为":"Save as",
            "删除":"Delete",
            "是否对模版字段进行修改":"Whether to modify the template field",
            "保存":"Save",
            "模版保存成功":"The template was saved successfully",
            "通过列号定位列":"Locate columns by column number",
            "请选择导入格式":"Please select import format",
            "未获取到对应的类型字段信息":"The corresponding type field information was not obtained",
            "加载":"Load",
            "表头信息有误":"The header information is incorrect",
            "请选择格式":"Please choose a format",
            "模版删除成功":"Template deleted successfully",
            "取消另存为":"Unsave as",
            "导入Excel标题":"Import Excel header",
            "确定":"Determine",
            "请设置导入列":"Please set the import column",
            "列名称":"Column name",
            "是否删除此模版":"Whether to delete this template",
            "否":"No",
            "提示":"Hint",
            "Excel导入自定义格式设置":"Excel import custom formatting",
            "字段名":"Field name",
            "识别列号":"Identification column number",
            "是":"Yes",
            "确定删除此行吗":"Are you sure to delete this line?",
            "取消":"Cancel",
            "模版另存为成功":"Save the template as successfully",
            "标题导入成功":"The title is imported successfully, you can set it yourself",
            "自定义格式":"Custom format",
            "取消修改":"Cancel Modify",
            "操作":"Operation",
            "是否保存为通用模版":"Whether to save as a universal template "
        },
        "ZmBaseExport":{
            "创建导出任务失败":"Failed to create export task!",
            "直接导出表格中可以看到的所有列":"Directly export all the columns that can be seen in the table",
            "创建导出任务成功":"The export task was created successfully, please download it from the export list later!",
            "请选择一条数据":"Please select a piece of data",
            "导出可视列":"Export visible columns",
            "另存为":"Save as",
            "删除":"Delete",
            "是否对模版字段进行修改":"Whether to modify the template field",
            "保存":"Save",
            "获取表格列信息失败":"Failed to get table column information !",
            "请选择通用模版":"Please select a general template",
            "模版保存成功":"The template was saved successfully",
            "自定义导出":"Custom export",
            "Excel自定义导出":"Excel custom export &",
            "模版删除失败":"Template deletion failed",
            "可选格式":"Optional format",
            "模版删除成功":"Template deleted successfully",
            "请选择数据":"Please select data",
            "取消另存为":"Unsave as",
            "确定":"Determine",
            "列名称":"Column name",
            "是否删除此模版":"Whether to delete this template",
            "提示":"Hint",
            "请稍后在导出列表中下载":"Please download in the export list later",
            "模版保存失败":"Failed to save template",
            "请选择导出列":"Please select an export column",
            "请输入模版名称":"Please enter a template name",
            "导出":"Export",
            "取消":"Cancel",
            "模版另存为成功":"Save the template as successfully",
            "导出列":"Export column",
            "待导出列":"Column to be exported",
            "已经是列表中最后一条数据":"Already the last data in the list",
            "取消修改":"Cancel Modify",
            "模版另存为失败":"Failed to save template as",
            "已经是列表中第一条数据":"Is already the first data in the list ",
            "创建导出任务成功，请在导出列表中进行下载": "The export task has been successfully created. Please download it from the export list"
        },
        "ZmMessage":{
            "下一条":"Next",
            "忽略":"Neglect",
            "回复":"Reply",
            "已是最后一条消息,2秒后自动关闭":"It is the last message and will automatically close after 2 seconds",
            "不再提醒":"No more reminders",
            "新消息":"New news "
        },
        "zmCallTable":{
            "请选择数据":"Please select data",
            "序号":"No.",
            "编码":"Coding",
            "名称":"Name",
            "调用表配置加载失败":"Failed to load the configuration of the call table, please contact the administrator!",
            "调用表信息不存在":"The call table information does not exist, please contact the administrator!",
            "移除监听":"Remove monitor",
            "刷新":"Refresh",
            "开启监听":"Turn on monitoring",
            "查找":"Find",
            "输入框回车":"Enter the box",
            "取消":"Cancel",
            "选取":"Select",
            "未查询到数据":"No data is found, please re-enter! "
        },
        "Developmenting":{
            "程序正在加紧研发":"The program is stepping up research and development, so stay tuned. . . "
        },
        "ZmToolBox":{
            "请选择打印机":"Please select a printer",
            "打印类型数据有误":"Incorrect print type data",
            "选择模板":"Choose a template",
            "打印参数不能为空":"Print parameter cannot be empty",
            "缩放类型只能为":"The zoom type can only be 0,1,2",
            "请输入文件地址":"Please enter the file address",
            "上下偏差只能输入数字":"Only numbers can be entered for upper and lower deviation",
            "旋转类型只能为":"The rotation type can only be 0,1,2,3",
            "报表类型不能为空":"The report type cannot be empty",
            "偏差值只能在30和-30之间":"The deviation value can only be between 30 and -30！",
            "打印方式只能为":"The printing method can only be 'sys','pdf'!",
            "单位":"Unit",
            "打印窗口":"Print window",
            "是否预览":"Whether to preview",
            "获取对应打印格式的对象数据":"Obtain the object data corresponding to the print format",
            "请传入打印参数":"Please pass in the printing parameters",
            "保存为默认":"Save as default",
            "打印份数":"Number of prints",
            "打印机":"Printer",
            "打印失败":"Print failed",
            "上下偏差":"Up and down deviation",
            "左右偏差只能输入数字":"Left and right deviation can only enter numbers",
            "来源类型不能为空":"Source type cannot be empty",
            "导出窗口":"Export window",
            "打印成功":"Printed successfully",
            "该打印模版未设计模版":"The print template has not been designed, please design it before printing",
            "该导出模版未设计模版":"There is no template designed for this export template, please design first before exporting",
            "打印类型不能为空":"Print type cannot be empty",
            "打印场景":"Print scene",
            "文件地址":"File address",
            "保存默认配置成功":"Save the default configuration successfully",
            "来源类型只能为":"The source type can only be one of'Base64','http','RawText','LocalFile'",
            "打印场景不能为空":"The print scene cannot be empty",
            "打印数据来源不能为空":"Print data source cannot be empty",
            "请选择运单打印机":"Please choose a waybill printer",
            "毫米":"Mm",
            "判断参数":"Judgment parameter",
            "请选择模版":"Please select a template",
            "打印":"Print",
            "导出":"Export",
            "左右偏差":"Left-right deviation",
            "物流助手初始化失败":"The logistics assistant failed to initialize, please try again later "
        },
        "ImportLog":{
            "查询":"Search",
            "导入网点":"Import outlets",
            "批次号":"batch number",
            "导入人":"Importer",
            "重置":"Reset",
            "状态":"State",
            "总行数":"Total number of rows",
            "导入文件":"Importing files",
            "网点":"Outlets",
            "错误描述":"Wrong description",
            "导入时间":"Import time",
            "错误行数":"Number of error lines "
        },
        /* zmfront-framework */
        "CallTable":{
            "调用表配置加载失败":"Failed to load the configuration of the call table, please contact the administrator!",
            "调用表信息不存在":"The call table information does not exist, please contact the administrator!"
        },
        "TreeTable":{
            "序号":"No."
        },
        "zmExportButton":{
            "创建导出任务失败":"Failed to create export task!",
            "创建导出任务成功":"The export task is successfully created, please download it from the export list later!",
            "请选择一条数据":"Please select a piece of data",
            "另存为":"Save as",
            "删除":"Delete",
            "是否对模版字段进行修改":"Whether to modify the template field",
            "保存":"Save",
            "请选择通用模版":"Please select a general template",
            "模版保存成功":"The template was saved successfully",
            "自定义导出":"Custom export",
            "Excel自定义导出":"Excel custom export",
            "模版删除失败":"Template deletion failed",
            "可选格式":"Optional format",
            "模版删除成功":"Template deleted successfully",
            "请选择数据":"Please select data",
            "取消另存为":"Unsave as",
            "确定":"Determine",
            "列名称":"Column name",
            "是否删除此模版":"Whether to delete this template",
            "提示":"Hint",
            "模版保存失败":"Failed to save template",
            "请选择导出列":"Please select an export column",
            "请输入模版名称":"Please enter a template name",
            "请选择指定模版":"Please select the specified template",
            "导出":"Export",
            "取消":"Cancel",
            "模版另存为成功":"Save the template as successfully",
            "导出列":"Export column",
            "待导出列":"Column to be exported",
            "已经是列表中最后一条数据":"Already the last data in the list",
            "取消修改":"Cancel Modify",
            "模版另存为失败":"Failed to save template as",
            "已经是列表中第一条数据":"Is already the first data in the list ",
            "创建导出任务成功，请在导出列表中进行下载": "The export task has been successfully created. Please download it from the export list"
        },
        "SimpleTable":{
            "选项表配置加载失败":"Failed to load the option table configuration, please contact the administrator!"
        },
        "CommonTable":{
            "再做保存":"Save again",
            "表格配置信息保存失败":"Failed to save table configuration information",
            "请选择列":"Please select a column",
            "表格配置":"Form configuration",
            "另存为":"Save as",
            "以下单号在查询结果中不存在":"The following tracking numbers do not exist in the query results",
            "保存":"Save",
            "笔":"笔",
            "输入关键字搜索":"Enter keywords to search",
            "附件":"Appendix",
            "请选择数据":"Please select data",
            "格式删除成功":"Format deleted successfully",
            "表格配置另存为失败":"Failed to save table configuration as",
            "注意":"Notice",
            "排序":"Sort",
            "序号":"No.",
            "删除":"Delete",
            "以下单号存在重复":"The following tracking numbers are duplicated",
            "提示":"Hint",
            "是否显示":"Whether to show",
            "是否删除此格式":"Whether to delete this format",
            "共":"altogether",
            "重排":"rearrange",
            "取消":"Cancel",
            "复制当前行":"Copy the current line",
            "已经是列表中最后一条数据":"Already the last data in the list",
            "请选择过滤数据列":"Please select a filter data column",
            "已经是列表中第一条数据":"Is already the first data in the list",
            "需在主页面上设置好":"Need to be set up on the main page",
            "请设置配置信息":"Please set configuration information",
            "复制所有行":"Copy all rows",
            "保存并加载":"Save and load",
            "复制选择行":"Copy selection line",
            "必须设置显示列":"Must set display column",
            "列宽":"Column width",
            "顺序重置":"Order reset",
            "可选格式":"Optional format",
            "表格配置信息保存成功":"The table configuration information was saved successfully",
            "请选择格式":"Please choose a format",
            "表格配置另存为成功":"The table configuration was saved as successfully",
            "关于列宽调整":"About column width adjustment",
            "格式删除失败":"Format deletion failed",
            "请选择数据列或未获取到数据":"Please select a data column or no data is obtained",
            "请选择表格配置":"Please select form configuration",
            "配置":"Configuration",
            "取消另存为":"Unsave as",
            "确定":"Determine",
            "复制区域内容":"Copy area content",
            "请输入模版名称":"Please enter a template name",
            "数据":"Data",
            "过滤值":"Filter value",
            "取消删除":"Undelete "
        },
        "ZmDate":{
            "最近两天":"The last two days",
            "开始日期":"Start date",
            "日期跨度不能超过":"Date span cannot exceed",
            "天":"Day",
            "一周前":"A week ago",
            "昨天":"Yesterday",
            "最近一周":"Last week",
            "最近一个月":"Last month",
            "结束日期":"End date",
            "一月前":"A month ago",
            "最近三个月":"Last three months",
            "今天":"Today",
            "当天":"That day "
        },
        "tagsView":{
            "关闭所有":"Close all",
            "关闭其他":"Close other "
        },
        "zmFileUpload":{
            "点击上传":"Click upload",
            "导入":"Import",
            "导入Excel标题":"Import Excel Header",
        },
        "ZmNo":{
            "清":"X",
            "空":"",
            "个":"indivual",
            "单号不能超过":"Order number cannot exceed "
        },
        "ZmMsgSend":{
            "短信通知":"SMS notification",
            "接收人":"Receiver",
            "接收人手机":"Recipient's mobile phone",
            "发送":"Send",
            "关闭":"Closure",
            "发送失败":"Failed to send",
            "发送成功":"Sent successfully",
        },
        "ZmPrintChildNo":{
            "Label打印":"Label print",
            "单件补打":"One-piece replacement",
            "打单信息":"Order information",
            "运单号码":"Waybill number",
            "转单号码":"Tracking number",
            "走货路线":"Delivery route",
            "寄件帐号":"Shipping account",
            "件数":"Number of pieces",
            "注意":"Notice",
            "可选择指定的子单进行补单":"You can choose the specified sub-order to make up the order",
            "用于单件货物联破损":"Used for damage of single piece of cargo",
            "只适用于号码段分配":"Only applicable to number segment allocation",
            "如DHL5.3系统号码段分配":"Such as DHL5.3 system number segment allocation",
            "和子单有独立PDF的接口":"Separate PDF interface with sub-list",
            "如":"E.g",
            "下载":"Download",
            "打印":"Print",
            "预览":"Preview",
            "关闭":"Closure",
            "子单号码":"Sub-order number",
            "没有子单列表":"No sub-list",
            "请选择需要下载的数据":"Please select the data to download",
            "请选择需要预览的数据":"Please select the data to be previewed",
            "不支持预览的格式":"Unsupported preview format",
            "获取子单的PDF合并文件异常":"The PDF merged file of the sub-order is abnormal",
            "不支持的格式":"Unsupported format",
            "没有可以打印数据":"No data can be printed",
            "单件信息中没有Label不能打印":"Cannot print if there is no Label in the single piece information "
        },
        "ZmInvoicePreApplyBatch":{
            "补录信息":"Supplementary information",
            "运单号码":"Waybill number",
            "补录原因":"Reason for Supplementary Record",
            "费用信息":"Cost information",
            "科目":'Suject ',
            "计算公式":"Calculation formula",
            "金额":"Amount",
            "币别":"Currency",
            "账单备注":"Bill remarks",
            "内部备注":'Internal remarks ',
            "保存并继续":"Save&continue",
            "保存":"Save",
            "关闭":"Closure",
            "请输入正确的公式":"Please enter the correct formula",
            "当前":"Current",
            "笔单号有问题":"笔单号有问题",
            "批量添加":"Batch add",
            "笔单号":"笔单号",
        },
        "ZmAgentRegistrationAfter":{
            "问题件信息":"Problem information",
            "问题单号":"Question number",
            "问题状态":"Problem status",
            "截止处理时间":"Deadline for processing",
            "问题描述":"Problem Description",
            "处理状态":"Processing status",
            "通知人":"Alert others",
            "可多选":"Multiple choice",
            "登记":"Register",
            "关闭":"Closure",
            "登记异常":"Registration exception",
            "登记成功":"Registered successfully",
            "文件大小不能大于5MB":"File size cannot be larger than 5MB",
            "只能上传jpg/png/word/excel/pdf文件":"Only jpg/png/word/excel/pdf files can be uploaded",
            "获取问题状态信息失败":"Failed to obtain problem status information",
            "获取运单信息失败":"Failed to get waybill information",
            "内容有修改,是否确认关闭？":"The content has been modified, are you sure to close it?",
            "提示":"Hint",
            "确定":'Determine',
            "取消":"Cancel",
            "问题号码":"Question number",
            "多笔转单/运单回车换行输入":"Multiple transfer/waybill carriage return and line feed input",
            "批量登记":"Bulk registration",
            "批量登记异常":"Batch registration exception",
            "当前有":"Currently have",
            "笔运单未能成功登记问题件":"笔运单未能成功登记问题件",
            "批量登记成功！":"Batch registration is successful!",
        },
        "ZmPrintGeneral":{
            "打印窗口":"Print window",
            "选择模板":"Choose a template",
            "打印机":"Printer",
            "打印":"Print",
            "预览":"Preview",
            "保存默认":"Save default",
            "关闭":'Close',
            "请选择要打印的打单记录！":"Please select the order record to be printed!",
            "请先配置LABEL打印机":"Please configure LABEL printer first",
            "请先配置INVOICE打印机":'Please configure INVOICE printer first ',
            "请先配置备份联打印机":'Please configure the backup printer first ',
            "请先配置电池信打印机":'Please configure the battery letter printer first ',
            "没有找到打印配置":'No print configuration found ',
            "获取合并文件异常，稍后重试！":'Failed to get the merged file, try again later! ',
            "获取默认模版异常！":"Get the default template exception!",
            "没有设置模板！":'No template is set! ',
            "获取模板列表异常！":"Get template list exception!",
            "无Invoice":"No Invoice",
            "无备份联":"No backup link",
            "没有配置自定义输出方式":"No custom output mode is configured",
            "获取api打单参数异常！":"Get api order parameter exception!",
            "模板不能为空":"Template cannot be empty",
            "打印机不能为空":"Printer cannot be empty",
            "保存默认打印机成功！":"Save the default printer successfully!",
        },
        "ZmProblems":{
            "问题件信息":"Problem information",
            "运单号码":"Waybill number",
            "转单号码":"Tracking number",
            "处理网点":"Processing outlets",
            "客户信息":"Customer Information",
            "指定路线":"Channel Code",
            "走货路线":"Delivery route",
            "件数/收费重":"Pieces/Charge weight",
            "目的地/收件邮编":"Destination/Consignee postcode",
            "问题描述":"Problem Description",
            "处理意见":"Handling opinions",
            "输入处理意见后，可Enter/回复提交":"After inputting the handling comments, you can enter/reply to submit After inputting the handling comments, you can enter/reply to submit",
            "处理状态":"Processing status",
            "处理结果":"process result",
            "通知人(可多选)":"Alert others",
            "回复":"Reply",
            "关闭":"Close",
            "获取文件路径异常":"Obtaining the file path is abnormal",
            "文件大小不能大于15MB":"File size cannot be larger than 15MB",
            "只能上传jpg/png/word/excel/pdf文件":"Only jpg/png/word/excel/pdf files can be uploaded",
            "文件还未上传成功，请等待文件上传成功后再回复！":"The file has not been uploaded successfully, please wait for the file to upload successfully before replying ！",
            "处理状态不能为空":"Processing status cannot be empty",
            "确定申请退返客户吗?":"Are you sure to apply for return to the customer?",
            "提示":"Hint",
            "确定":"Determine",
            "取消":"Cancel",
            "确定申请销毁吗?":"Are you sure to apply for destruction?",
            "回复异常":"Reply exception",
            "回复成功！":"Reply successfully!",
            "问题状态":"Problem status",
            "附件":"Appendix",
            "指定处理人":"Designated processor",
            "处理时限":"Processing time limit",
            "登记":"Register",
            "登记异常":"Registration exception",
            "登记成功！":"Registration is successful!",
            "获取问题状态信息失败！":"Failed to get problem status information!",
            "获取运单信息失败！":"Failed to obtain waybill information!",
            "内容有修改,是否确认关闭？":"The content has been modified, are you sure to close it?",
            "截止处理时间":"Deadline for processing",
            "需回复":"Need to reply",
            "文件大小不能大于5MB":"File size cannot be larger than 5MB",
            "多笔运单回车换行输入":"Carriage return and line feed input for multiple waybills",
            "批量登记":"Bulk registration",
            "批量登记异常":"Batch registration exception",
            "当前有":"Currently have",
            "笔运单未能成功登记问题件":"笔运单未能成功登记问题件",
            "批量登记成功！":"Batch registration is successful!",
            "多笔转单/运单回车换行输入":"Multiple transfer/waybill carriage return and line feed input",
            "问题件回复":"Question response",
            "运单号码/转单号码/参考编号":"Order Number/Tracking Number/Ref number",
            "收件城市/收件邮编":"Consignee city/Consignee postcode",
            "目的地":"Destination",
            "指定路线/走货路线":"Channel Code/Delivery route",
        },
        "PosPrintSetting":{
            "打印设置":"Print Settings",
            "打印机设置":"Printer settings",
            "LABEL打印机":"LABEL printer",
            "INVOICE打印机":"INVOICE printer",
            "备份联打印机":"Backup printer",
            "电池信打印机":"Battery letter printer",
            "文件保存路径":"File save path",
            "发票份数":"Number of invoices",
            "备份联份数":"Number of backup copies",
            "是否合并":"Whether to merge",
            "打印类型":"Print type",
            "关闭":"Close",
            "保存":"Save",
            "发票份数不能为空且必须大于0":"The number of invoice copies cannot be empty and must be greater than 0",
            "备份联份数不能为空且必须大于0":"The number of backup copies cannot be empty and must be greater than 0",
        }
    }
};
export default enUS;



// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/locale/components_en-US.js